import React from 'react'
import moment from 'moment'

const InfoTooltip: React.FC<Orphan> = orphan => {
    return(
        <div className="info-icon">
            {orphan.type === 'onshore' ? (
                <i className="fas fa-image"></i>
            ) : orphan.type === 'offshore_static' || orphan.type === 'offshore_floating' ? (
                <i className="fas fa-ship"></i>
            ) : (
                <i className="fas fa-info-circle"></i>
            )}
            <div className="tooltip">
                <ul className="fa-ul">
                    <li>
                        <span className="description">Live Wellbore Name: </span>
                        <span className="value">{orphan.name}</span>
                    </li>
                    <li>
                        <span className="description">Live Wellbore ID: </span>
                        <span className="value">{orphan.id}</span>
                    </li>
                    <li>
                        <span className="description">EDM DB Link: </span>
                        <span className="value">{orphan.edmXRef?.edmDBLink}</span>
                    </li>
                    <li>
                        <span className="description">EDM Wellbore Name: </span>
                        <span className="value">{orphan.edmXRef?.wellboreName}</span>
                    </li>
                    <li>
                        <span className="description">Actual Wellbore Name: </span>
                        <span className="value">{orphan.edmXRef?.actualWellboreName}</span>
                    </li>
                    <li>
                        <span className="description">SPUD Date: </span>
                        <span className="value">{orphan.edmXRef?.edmUIDWellbore}</span>
                    </li>
                    <li>
                        <span className="description">Updated By: </span>
                        <span className="value">{orphan.edmXRef?.username}</span>
                    </li>
                    <li>
                        <span className="description">Updated On: </span>
                        <span className="value">{moment(orphan.edmXRef?.lastUpdatedOn).format('YYYY-MM-DD HH:mm:ss')}</span>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default InfoTooltip
